export default __webpack_public_path__ + "static/social-media-ads-5ac148e26e73eff5d729c8ff87b28c46.png";